import React from "react";
import { ALL_LOCATIONS } from './constants';
import "./MileageDisplay.css";

function getWeeksSoFarIn2026() {
  const startOf2026 = new Date("2026-01-01");
  const now = new Date();

  if (now < startOf2026) return 1; // avoid divide-by-zero early in the year

  const msPerWeek = 1000 * 60 * 60 * 24 * 7;
  const diffMs = now - startOf2026;

  return Math.max(1, Math.ceil(diffMs / msPerWeek));
}

export default function MileageDisplay({ imageUrl, name, milesTraveled, message, eggs }) {
  const weeksSoFar = getWeeksSoFarIn2026();
  const weeklyAverage = (milesTraveled / weeksSoFar);

  const hobbitonTidings = [
    "Oof, a respectable start. Might be time for second breakfast or third...",
    "I step into legend! But only after I finish this cup of tea.",
    "No turning back now! (Unless I forgot something at home.)",
    "The journey begins with courage… and an emergency biscuit supply.",
    "Let the Fellowship know: I have begun… at a reasonable and safe pace.",
    "Mordor here I come! Maybe after a quick nap.",
    "Today I march! Tomorrow I may rest. But today, I MARCH!",
    "The road calls to me! And I have answered... somewhat cautiously.",
    "Adventure awaits!! And can await a bit longer for me to finish my snacks.",
    "Phew, that was enough adventure for me today!",
    "I have ventured forth! Someone please tell my bed I’ll be back later.",
    "I have begun the quest! Slightly earlier than I feel emotionally prepared for.",
    "REMEMBER ME, SWEET BED",
    "AVENGE ME WHEN/IF I DIE, SWEET BED",
  ]

  const rivendellTidings = [
    "We're on our way now! We're not sure if this is wise, but here we go!",
    "Step by step into the unknown.. but maybe not that fast.",
    "The journey deepens. So does our concern..",
    "The path is set. We are on it. Emotionally, we are still processing.",
    "This is the part of the journey where snacks become strategic resources.",
    "Every mile feels like a decision we must emotionally recover from.",
  ]

  const lothlorienTidings = [
    "Time and distance feels strange here. So do our legs.",
    "Somehow this is peaceful. We’re suspicious of it.",
    "We are not lost. We are… gently drifting through the woods.",
    "Anyone wanna join a run club?",
    "Mordor feels closer. Our energy does not.",
  ]

  const raorosTidings = [
    "We can see it now… which is both inspiring and deeply concerning.",
    "The road grows hard. And so do I? Emotionally, mostly.",
    "The air feels heavier. So does every single step.",
    "Still moving forward. Still slightly confused. Still committed.",
    "Running is my new personality. Or maybe delusion is my new personality?",
    "GONDOR CALLS FOR AID!!! Ask if they can they wait.",
  ];

  const mordorTidings = [
    "MOVE, worm!",
    "AAAAOOOOOAOOOOOOOOAAAAAAAAAAAAA",
    "Literally everything hurts",
    "Victory is ours! The Shire will hear of this… repeatedly.",
    "One does not simply walk to Mordor… except I just did.",
  ] 
  
  function getTidingsPool(miles) {
    if (milesTraveled >= ALL_LOCATIONS[4].miles) return mordorTidings;
    if (milesTraveled >= ALL_LOCATIONS[3].miles) return raorosTidings;
    if (milesTraveled >= ALL_LOCATIONS[2].miles) return lothlorienTidings;
    if (milesTraveled >= ALL_LOCATIONS[1].miles) return rivendellTidings;
    return hobbitonTidings;
  }

  const tidingsPool = getTidingsPool(milesTraveled);

  const displayMessage =
    message && message.trim() !== ''
      ? message
      : tidingsPool[Math.floor(Math.random() * tidingsPool.length)];

  return (
    <div className="mileage-container">
      <div className="mileage-top">
        <img src={imageUrl} alt={name} className="mileage-image" />

        <div className="mileage-info">
          <div><strong>Name:</strong> {name}</div>
          <div><strong>Miles traveled:</strong> {milesTraveled.toFixed(2)} miles</div>
          <div><strong>Weekly Average:</strong> {weeklyAverage.toFixed(2)} miles/week</div>
          <div><strong>Egged:</strong> {eggs} times </div>
        </div>
      </div>

      <div className="battlecry-wrap" aria-label="Battlecry">
        <div className="battlecry-box">
          <div className="battlecry-text">{displayMessage}</div>
        </div>
      </div>
    </div>
  );
}
